import { useSelector, useDispatch } from 'react-redux';
import { Box, Modal } from '@mui/material';
import { SET_MODAL_STATUS, SET_FIRST_TIME_LOGIN, SET_MODAL_TYPE } from 'store/actions';
import FeedbackModal from './Feedback';
import PlansModal from './Plans';
import SuccessModal from './Stripe/Success';
import FailureModal from './Stripe/Failure';
import PremiumSuccessModal from './Stripe/premiumSuccess';
import FreemiumSuccessModal from './Stripe/freemiumSuccess';
import NotSubscribedModal from './NotSubscribed';
import NotSubscribedForNonCreatorModal from './NotSubscribedForNonCreator';
import PerfectScrollbar from 'react-perfect-scrollbar';
import StillVerifyingModal from './StillVerifying';
import LostAccessModal from './LostAccess';
import UpgradetoPremiumAlertNonAdmin from './UpgradeToPremiumAlertNonAdmin';
import { useNavigate } from 'react-router';
import { UPGRADE_PREMIUM } from 'helper/checkPlan.helper';
import DowngradePremiumSuccess from './Stripe/downgradePremiumSuccess';
function DashboardModalBox() {
    const navigate = useNavigate();
    const { modalStatus, modalType } = useSelector((state) => state.customization);
    const dispatch = useDispatch();
    const handleClose = () => {
        if (modalType === 'freemium_success' || modalType === 'premium_success') navigate('/dashboard');
        dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
        dispatch({ type: SET_FIRST_TIME_LOGIN, firstTimeLogin: false });
    };
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: 24
    };
    const arrayOfBlackListedModal = Object.keys(UPGRADE_PREMIUM).map((key) => UPGRADE_PREMIUM[key]);
    if (arrayOfBlackListedModal.includes(modalType)) return '';
    return (
        <Modal
            open={modalStatus}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={`${modalType === 'plans' ? 'modal-lg' : ''} ${
                modalType === 'freemium_success' || modalType === 'downgrade_premium_success' ? 'freemium-success-modal plan-modal' : ''
            } ${modalType === 'premium_success' || modalType === 'downgrade_premium_success' ? 'premium-success-modal plan-modal' : ''}`}
        >
            {modalType === 'first_time_login' ? (
                <Box className="modal-box-2 modal" sx={style}>
                    <PerfectScrollbar style={{ maxHeight: '80vh' }}>
                        <StillVerifyingModal />
                    </PerfectScrollbar>
                </Box>
            ) : modalType === 'lost_access' ? (
                <LostAccessModal />
            ) : modalType === 'non_permit_upgrade' ? (
                <UpgradetoPremiumAlertNonAdmin />
            ) : (
                <Box sx={style} className="modal-box modal">
                    <PerfectScrollbar style={{ maxHeight: '80vh' }}>
                        {modalType === 'feedback' && <FeedbackModal />}
                        {modalType === 'plans' && <PlansModal />}
                        {modalType === 'stripe_success' && <SuccessModal />}
                        {modalType === 'stripe_failure' && <FailureModal />}
                        {modalType === 'not_subscribed' && <NotSubscribedModal />}
                        {modalType === 'not_subscribed_non_creator' && <NotSubscribedForNonCreatorModal />}
                        {modalType === 'freemium_success' && <FreemiumSuccessModal />}
                        {modalType === 'premium_success' && <PremiumSuccessModal />}
                        {modalType === 'downgrade_premium_success' && <DowngradePremiumSuccess />}
                    </PerfectScrollbar>
                </Box>
            )}
        </Modal>
    );
}

export default DashboardModalBox;
